<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import { BaseAtom } from "components/cards/atoms";
export let container;
</script>

<style></style>

<BaseAtom _isotope="RSVPFormAtom" {...container}>
  <div>RSVP Form Placeholder</div>
</BaseAtom>